import { noneGroupHeader } from '../utils/noneGroupHeader.locstring.json';
import loc from 'owa-localize';
import type GroupHeader from '../type/GroupHeader';
import type { GroupHeaderId } from '../type/GroupHeaderId';
import type { LocalizedString } from 'owa-localize';
import type { TableView } from 'owa-mail-list-store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { SubjectGroupHeaderId } from '../type/GroupHeaderId';
import getNormalizedSubject from 'owa-mail-compose-actions/lib/utils/getNormalizedSubject';

export default function getGroupHeaderForSortBySubject(
    rowKey: string,
    tableView: TableView
): GroupHeader {
    const subject: string = getNormalizedSubject(
        MailRowDataPropertyGetter.getSubject(rowKey, tableView) ?? ''
    );
    let subjectText = loc(noneGroupHeader);
    let subjectGroupHeaderId: GroupHeaderId = SubjectGroupHeaderId.Subject;

    if (subject !== '') {
        subjectText = subject as any as LocalizedString;
        subjectGroupHeaderId = subject;
    }

    return {
        headerText: () => subjectText,
        headerId: subjectGroupHeaderId,
    };
}
